export class BdsDialogMultiConfirmModel {
    title?: string;
    content: string;
    actionText: string;
    actionTwoText?: string;
    showActionTwo?: boolean = false;
    dismissiveText?: string = 'Cancel';
}
